import { ChartEmptyState } from '@eggplant/pattern-library'
import type { CSSProperties, ReactNode } from 'react'

interface Props {
  icon: ReactNode
  title: string
  children: ReactNode
  link?: ReactNode
}

const wrapperStyle: CSSProperties = {
  display: 'grid',
  minHeight: '16em'
}

const NoDataPlaceholder = ({
  icon,
  title,
  children,
  link
}: Props) =>
  <div style={wrapperStyle}>
    <ChartEmptyState
      icon={icon}
      linkTo={link}
      title={title}
    >
      {children}
    </ChartEmptyState>
  </div>

export default NoDataPlaceholder
